"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbacksClient = void 0;
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class CallbacksClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async createCallbackSubscription(request) {
        const path = (0, url_1.buildPathAndQuery)('/callback-subscriptions', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getCallbackSubscriptionById(request) {
        const path = (0, url_1.buildPathAndQuery)('/callback-subscriptions/:callbackSubscriptionId', {
            path: { callbackSubscriptionId: request.callbackSubscriptionId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listCallbackSubscriptions() {
        const path = (0, url_1.buildPathAndQuery)('/callback-subscriptions', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async archiveCallbackSubscription(request) {
        const path = (0, url_1.buildPathAndQuery)('/callback-subscriptions/:callbackSubscriptionId', {
            path: { callbackSubscriptionId: request.callbackSubscriptionId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'DELETE',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getCallbackEventById(request) {
        const path = (0, url_1.buildPathAndQuery)('/callback-events/:callbackEventId', {
            path: { callbackEventId: request.callbackEventId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listCallbackEvents() {
        const path = (0, url_1.buildPathAndQuery)('/callback-events', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.CallbacksClient = CallbacksClient;
